class UseSubPageAppId {
  constructor(vue) {
    this.context = vue
  }
  async init() {
    console.log("this.context", this.context.options)
    // 获取当前详情页的appId
    const appId = this.context.$store.state.states.getDataPageIds.appId
    // 更新当前组件的appId
    this.context.$changeOptionsEV(appId, "appId", false, null, { ...this.context.myid })
  }
}
export default {
  methods: {
    useSubPageAppIdPlugin() {
      const useSubPageAppId = new UseSubPageAppId(this)
      useSubPageAppId.init()
    }
  }
}
